import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import ShouldRender from '~/components/ShouldRender'
import defaultBanner from '~/util/community-default-banner-picture.jpg'

import * as S from './styled'

const SponsoredBannerPreview = ({ billboardMedia, compactMedia, mediumMedia }) => {
  const { t } = useTranslation()

  return (
    <S.Container>
      <S.ImagePreviewContainer>
        <S.Title>{t('billboard')}</S.Title>

        <S.BannerContainer>
          <ShouldRender if={billboardMedia}>
            <S.BillboardImagePreview src={billboardMedia} />
            <S.BillboardBorder />
            <S.BillboardSafeArea />
          </ShouldRender>

          <ShouldRender if={!billboardMedia}>
            <S.BillboardImagePreview src={defaultBanner} />
          </ShouldRender>
        </S.BannerContainer>
      </S.ImagePreviewContainer>

      <S.ImagePreviewContainer>
        <S.Title>{t('compactRectangle')}</S.Title>

        <S.BannerContainer>
          <ShouldRender if={compactMedia}>
            <S.CompactImagePreview src={compactMedia} />
            <S.CompactBorder />
            <S.CompactSafeArea />
          </ShouldRender>

          <ShouldRender if={!compactMedia}>
            <S.CompactImagePreview src={defaultBanner} />
          </ShouldRender>
        </S.BannerContainer>
      </S.ImagePreviewContainer>

      <S.ImagePreviewContainer>
        <S.Title>{t('mediumRectangle')}</S.Title>

        <S.BannerContainer>
          <ShouldRender if={mediumMedia}>
            <S.MediumImagePreview src={mediumMedia} />
            <S.MediumBorder />
            <S.MediumSafeArea />
          </ShouldRender>

          <ShouldRender if={!mediumMedia}>
            <S.MediumImagePreview src={defaultBanner} />
          </ShouldRender>
        </S.BannerContainer>
      </S.ImagePreviewContainer>

      <S.DownloadContainer>
        <S.LightbulbIcon />

        <S.DownloadText>
          <Trans
            t={t}
            i18nKey="downloadSafeArea"
            components={[
              <a
                key="0"
                href="https://assets.abilitya.tech/banner_guideline.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('download')}
              </a>,
            ]}
          />
        </S.DownloadText>
      </S.DownloadContainer>
    </S.Container>
  )
}

export default SponsoredBannerPreview
